import { SearchResultItemDto } from '@groundfloor-platform/mgmt-service-g-sdk';
import { LocalShipping } from '@mui/icons-material';
import { DeliveryTypeIcon } from './delivery-type-icon.component';
import { ResultItemRow } from './result-item-row.component';
import { ResultStatusColumn } from './result-status-column.component';
import { dataString, resultDateLine } from '../search.utils';

export function DeliveryResultItem({
  item,
  href,
  onClick
}: {
  item: SearchResultItemDto;
  href?: string;
  onClick?: () => void;
}) {
  // The most identifying reference available: the parent order's number (OrderDeliveries), then
  // the delivery's own codes in priority order.
  const reference =
    dataString(item.data, 'orderNumber') ??
    dataString(item.data, 'collectionCode') ??
    dataString(item.data, 'barcode') ??
    dataString(item.data, 'carrierReference') ??
    dataString(item.data, 'deliveryReference');

  // Recipient headlines the row; the reference stands in when there is none (and the server
  // label — state or id — is the last resort).
  const recipientName = dataString(item.data, 'recipientName');
  const primary = recipientName ?? (reference ? `#${reference}` : item.label);

  return (
    <ResultItemRow
      icon={<DeliveryTypeIcon subType={item.subType} Fallback={LocalShipping} />}
      primary={primary}
      secondaryLines={[
        recipientName && reference ? `#${reference}` : undefined,
        dataString(item.data, 'hubName'),
        resultDateLine(item.data)
      ]}
      trailing={<ResultStatusColumn data={item.data} statusKey="state" />}
      href={href}
      onClick={onClick}
    />
  );
}
